import {MutationTree} from 'vuex';
import {
    BriefFreelancerJobTitle,
    BriefFreelancerProfile,
    BriefFreelancerSkills,
    BriefMissionDescription,
    BriefRouterParams,
    BriefState,
    BriefWhenConditions,
    BriefWhereConditions,
    Payload,
} from '@/brief-hub/store/modules/brief/types';
import BriefResource from '@/brief-hub/brief/BriefResource';

export enum MutationsType {
    RESET_BRIEF = 'resetBrief',
    SAVED_NOTIFICATION = 'savedNotification',
    SAVED_ACKNOWLEDGEMENT = 'savedAcknowledgement',
    UPDATE_BRIEF = 'updateBrief',
    UPDATE_BRIEF_FORM_JOB_TITLE = 'updateBriefFormJobTitle',
    UPDATE_BRIEF_FORM_PROFILE = 'updateBriefFormProfile',
    UPDATE_BRIEF_FORM_SKILLS = 'updateBriefFormSkills',
    UPDATE_BRIEF_FORM_WHEN = 'updateBriefFormWhen',
    UPDATE_BRIEF_FORM_WHERE = 'updateBriefFormWhere',
    UPDATE_BRIEF_FORM_MISSION_DESCRIPTION = 'updateBriefFormMissionDescription',
    PREFILL_STATE_FROM_STRATEGY = 'prefillBriefStateFromStrategy',
    UPDATE_PAYLOAD = 'updatePayload',
    UPDATE_ORIGIN_REFERRER = 'updateOriginReferrer',
    INFORMATION_MODAL_DISPLAYED = 'informationModalDisplayed',
}

export const mutations: MutationTree<BriefState> = {
    [MutationsType.RESET_BRIEF]: (state: BriefState): void => {
        state.brief = null;
        state.payload = null;
        state.briefForm = {
            jobTitle: null,
            skills: null,
            whenConditions: null,
            whereConditions: null,
            missionTitle: null,
            missionDescription: null,
            identity: null,
            profileDetails: null,
        };
    },

    [MutationsType.UPDATE_BRIEF]: (state: BriefState, payload: BriefResource): void => {
        state.brief = payload;
        state.payload = null;
    },

    [MutationsType.SAVED_NOTIFICATION]: (state: BriefState): void => {
        state.savedNotification = true;
    },

    [MutationsType.SAVED_ACKNOWLEDGEMENT]: (state: BriefState): void => {
        state.savedNotification = false;
    },

    [MutationsType.INFORMATION_MODAL_DISPLAYED]: (state: BriefState): void => {
        state.informationModalDisplayed = true;
    },

    [MutationsType.UPDATE_ORIGIN_REFERRER]: (state: BriefState, newReferrer: string): void => {
        if (!state.originReferrer && newReferrer.includes(window.location.hostname) && newReferrer !== window.location.href) {
            state.originReferrer = newReferrer;
        }
    },

    [MutationsType.UPDATE_BRIEF_FORM_JOB_TITLE]: (state: BriefState, payload: BriefFreelancerJobTitle): void => {
        state.briefForm.jobTitle = payload;
    },

    [MutationsType.UPDATE_BRIEF_FORM_PROFILE]: (state: BriefState, payload: BriefFreelancerProfile): void => {
        state.briefForm.profileDetails = {
            freelancerBonusSkills: [],
            freelancerCategories: payload.selectedCategory ? [payload.selectedCategory] : [],
            freelancerCategoryLabels: [],
            freelancerJobTitle: undefined,
            freelancerMandatorySkills: [],
            freelancerRequiredCategories: [],
            languages: [],
            experienceLevel: payload.selectedExperienceLevel || undefined,
            freelancerSkills: [],
            functionalScopes: [],
            industryExpertises: [],
        };
    },

    [MutationsType.UPDATE_BRIEF_FORM_SKILLS]: (state: BriefState, payload: BriefFreelancerSkills): void => {
        state.briefForm.skills = payload;
    },

    [MutationsType.UPDATE_BRIEF_FORM_WHEN]: (state: BriefState, payload: BriefWhenConditions): void => {
        state.briefForm.whenConditions = payload;
    },

    [MutationsType.UPDATE_BRIEF_FORM_WHERE]: (state: BriefState, payload: BriefWhereConditions): void => {
        state.briefForm.whereConditions = payload;
    },

    [MutationsType.UPDATE_BRIEF_FORM_MISSION_DESCRIPTION]: (state: BriefState, payload: BriefMissionDescription): void => {
        state.briefForm.missionDescription = payload;
    },

    [MutationsType.UPDATE_PAYLOAD]: (state: BriefState, payload: Payload): void => {
        state.payload = payload;
    },
    [MutationsType.PREFILL_STATE_FROM_STRATEGY]: (state: BriefState, payload: BriefRouterParams): void => {
        state.briefForm.jobTitle = {
            jobTitle: payload.jobTitle || null,
        };
        state.briefForm.profileDetails = {
            freelancerBonusSkills: [],
            freelancerCategories: payload.freelancerCategory ? [payload.freelancerCategory] : [],
            freelancerCategoryLabels: [],
            freelancerJobTitle: payload.jobTitle || undefined,
            freelancerMandatorySkills: [],
            freelancerRequiredCategories: [],
            languages: [],
            experienceLevel: payload.experienceLevel,
            freelancerSkills: [],
            functionalScopes: [],
            industryExpertises: [],
        };
        state.briefForm.whenConditions = {
            projectDuration: null,
            startDate: null,
            freelancerAvailability: null,
            budget: null,
            dailyFreelancerRate: payload.freelancerDailyRate || null,
            communicateRate: null,
        };
    },
};
